<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="1200px">
      <!-- .option设置 -->
      <div class="table">
        <ol>
          <!-- 附加服务中文名 -->
          <li>
            {{ $t('message.additionalServicesChinese') }}
          </li>
          <!-- 附加服务日文名 -->
          <li>
            {{ $t('message.additionalServicesJapanese') }}
          </li>
          <!-- 收费标准 -->
          <li class="flex05">
            {{ $t('message.chargingStandards') }}
          </li>
          <!-- 图片 -->
          <li>
            {{ $t('message.pic') }}
          </li>
          <!-- 视频 -->
          <li>
            {{ $t('message.video') }}
          </li>
          <!-- 文件 -->
          <li>
            {{ $t('message.file') }}
          </li>
          <!-- 特殊要求 -->
          <li>
            {{ $t('message.specialRequirements') }}
          </li>
        </ol>
        <ul v-for="(item, index) in optionlist" :key="index">
          <!-- 附加服务中文名 -->
          <li>
            <div class="template">
              <span style="margin-right: 7px;">
                {{ index + 1 }}
              </span> {{ item.name }}
            </div>
          </li>
          <!-- 附加服务日文名 -->
          <li>
            <div class="template">
              {{ item.name_translate }}
            </div>
          </li>
          <!-- 收费标准 -->
          <li class="flex05">
            <div class="template">
              {{ item.price }}
              <span style="margin-left: 7px;">
                {{ item.unit }}
              </span>
            </div>
          </li>
          <!-- 图片 -->
          <li>
            <div>
              <div class="pic-box">
                <div class="img" v-for="(img, imgIndex) in item.image_ext" :key="imgIndex">
                  <img :src="img" alt="">
                  <div class="btn">
                    <i class="el-icon-zoom-in" @click="handlePictureCardPreview(img)"></i>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!-- 视频 -->
          <li>
            <div>
              <div class="pic-box">
                <div class="img" v-for="(video, videoIndex) in item.video_ext" :key="videoIndex">
                  <video :src="video"></video>
                </div>
              </div>
            </div>
          </li>
          <!-- 文件 -->
          <li>
            <div class="file">
              <div class="item" v-for="(file, fileIndex) in item.file_ext" :key="fileIndex">
                <a :href="file" target="_blank" class="a-link word-break">{{ file }}</a>
              </div>
            </div>
          </li>
          <!-- 特殊要求 -->
          <li>
            <div class="template">
              {{ item.remark_ext }}
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>
    <!-- 图片放大 -->
    <el-dialog :visible.sync="picDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

  </div>
</template>
<script>
export default {

  data() {
    return {
      picDialogVisible: false,
      dialogVisible: false,
      dialogImageUrl: '',
      optionlist: [],
    };
  },
  methods: {
    // 设置数据
    setData(data) {
      this.optionlist = data
      this.dialogVisible = true
    },
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.picDialogVisible = true;
    },

  }
}
</script>
<style lang='scss' scoped>
.table {
  padding: 30px;

  li {
    justify-content: left;
    padding: 0 15px;
    position: relative;
  }

  .flex3 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  ol {
    height: 42px;
  }

  ul {
    background-color: #fff;
    min-height: 110px;
    padding: 5px 0;

    .template {
      display: flex;
      line-height: 36px;
    }

    /deep/.el-textarea__inner {
      height: 110px !important;
      width: 100% !important;
    }

    /deep/.el-upload-dragger {
      width: auto;
      height: auto;
      border: none;
    }

  }

  .file {
    width: 100%;

    .item {
      display: flex;
      width: 100%;
      margin-bottom: 10px;

      a {
        margin-right: 12px;
        flex: 1;
      }

      .el-icon-error {
        cursor: pointer;
        font-size: 16px;
        color: #B4272B;
        ;
      }
    }
  }

  .pic-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .img {
      position: relative;
      width: 50px;
      margin-right: 5px;

      &:hover {
        .btn {
          display: flex;
        }
      }

      .btn {
        position: absolute;
        top: 0;
        left: 0;
        width: 50px;
        height: 50px;
        background-color: rgba(0, 0, 0, 0.2);
        display: none;
        justify-content: center;
        align-items: center;
        border-radius: 5px;

        i {
          color: #fff;
          font-size: 16px;
          cursor: pointer;

          &:nth-last-child(1) {
            margin-left: 10px;
          }
        }
      }

      video {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }

      img {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }
    }
  }
}

.operation {
  margin-top: 24px;
}
</style>